"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  open(host, protocol, path) {
    const wsProtocol = protocol === 'http:' ? 'ws' : 'wss';
    const ws = new WebSocket(path.startsWith(wsProtocol) ? path : `${wsProtocol}://${host}${path}`);
    return new Promise((resolve, reject) => {
      ws.onopen = () => resolve(ws);
      ws.onerror = err => {
        reject(new Error(err));
      };
    });
  },
  onReceive(ws, cb) {
    ws.onmessage = cb;
  },
  onClose(ws, cb) {
    ws.onclose = cb;
  },
  send(ws, msg) {
    ws.send(JSON.stringify(msg));
  },
  close(ws) {
    ws.close();
  }
};